module.exports = __webpack_public_path__ + "static/img/pool page top img_desktop.f4816555.jpg";